<template :style="{ 'background-image': 'url(' + img/DXC_AWS.jpg + ')' }">
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      class="dash"
      justify-center
      wrap
    >
      <v-flex
        xs12
        md12
      >
        <v-card-text class="text-xs-center">
          <img
            :src="accountInventoryBg"
          >
        </v-card-text>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// Utilities
import {
  mapMutations,
  mapState
} from 'vuex'

export default {
  computed: {
    ...mapState('app', ['accountInventoryBg'])
  }
}

</script>
<style>
.dash {
  position: relative;
  padding-bottom:100px;
  top: 25%;
}
</style>
